import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=457b6dea&"
import script from "./Reception.vue?vue&type=script&lang=js&"
export * from "./Reception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports